<template>
  <div class="page-panel">
    <div class="page-panel__header">
      <div class="page-panel-header__title">用户管理</div>
    </div>
    <div class="page-panel__body">
      <el-form class="page-panel-search-form" :inline="true">
        <!-- <el-form-item>
              <el-input placeholder="请输入关键字"> </el-input>
            </el-form-item> -->
        <!-- <el-form-item>
              <el-button type="default" @click="getThreeLessonsList()" icon="el-icon-search"></el-button>
            </el-form-item> -->
        <el-form-item class="page-panel-search-form-right-button">
          <el-button type="primary" @click="newUser">新增</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="userList" border stripe>
        <el-table-column type="index" label="序号" width="90" align="center">
          <template slot-scope="scope">{{(scope.$index+1)+((searchModel.pageNo-1)*searchModel.pageSize)}}</template>
        </el-table-column>
        <el-table-column prop="userName" label="用户名" align="center" width="100">
        </el-table-column>
        <el-table-column label="真实姓名" align="center" prop="realName" width="100">
        </el-table-column>
        <el-table-column label="电话" align="center" prop="phone">
        </el-table-column>
        <el-table-column label="邮箱" align="center" width="90" prop="email">
        </el-table-column>
        <el-table-column label="性别" align="center">
          <template slot-scope="scope">
            {{
              scope.row.sex==0?'男':'女'
            }}
          </template>
        </el-table-column>
        <el-table-column prop="addTime" label="创建时间" align="center">
        </el-table-column>
        <el-table-column prop="foundUser" label="创建人" align="center">
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <!-- <el-button type="text" @click="getUserDetail(scope.row.userId,1)">查看</el-button>
            <el-button type="text" @click="getUserDetail(scope.row.userId,2)">编辑</el-button> -->
            <el-button type="text" @click="delUser(scope.row.userId)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="page-panel__footer">
        <el-pagination :current-page.sync='searchModel.pageNo' :page-size='searchModel.pageSize'
          layout='prev, pager, next, jumper' :total='total' @current-change="getUserList">
        </el-pagination>
      </div>
    </div>
    <el-dialog title="用户信息" :visible.sync="viewDialogVisable">
      <table class="form-editor">
        <table class="form-editor">
          <tr>
            <th>产品名称:</th>
            <td colspan="3">
              {{userParam.proTitle}}
            </td>
          </tr>
          <tr>
            <th>产品类型:</th>
            <td>
              <el-radio-group v-model="userParam.proType" disabled>
                <el-radio :label="0">产品展示</el-radio>
                <el-radio :label="1">技术服务</el-radio>
              </el-radio-group>
            </td>
          </tr>
          <tr>
            <th>产品效果图:</th>
            <td>
              <img :src="userParam.picMain" alt="产品效果图" onerror="this.src='/static/img/unload.gif" width="150">
            </td>
            <th>产品参数图:</th>
            <td>
              <img :src="userParam.picPara" alt="产品参数图" onerror="this.src='/static/img/unload.gif" width="150">
            </td>
          </tr>
          <tr>
            <th>产品简介:</th>
            <td colspan="3" v-html="userParam.proBody">
            </td>
          </tr>
          <tr>
            <th>是否推荐首页:</th>
            <td>
              <el-radio-group v-model="userParam.isRecom" disabled>
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </td>
          </tr>
        </table>
      </table>
    </el-dialog>
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisable">
      <table class="form-editor">
        <tr>
          <th>用户名:</th>
          <td>
            <el-input v-model="userParam.userName" placeholder="请输入用户名" auto-complete="new-user"></el-input>
          </td>
        </tr>
        <tr>
          <th>密码:</th>
          <td>
            <el-input v-model="userParam.password" placeholder="请输入密码" type="password" auto-complete="new-password">
            </el-input>
          </td>
        </tr>
        <tr>
          <th>真实姓名:</th>
          <td>
            <el-input v-model="userParam.realName" placeholder="请输入真实姓名"></el-input>
          </td>
        </tr>
        <tr>
          <th>手机号:</th>
          <td>
            <el-input v-model="userParam.phone" placeholder="请输入手机号"></el-input>
          </td>
        </tr>
        <tr>
          <th>邮箱:</th>
          <td>
            <el-input v-model="userParam.email" placeholder="请输入手机号"></el-input>
          </td>
        </tr>
        <tr>
          <th>性别:</th>
          <td>
            <el-radio-group v-model="userParam.sex">
              <el-radio :label=0>
                男
              </el-radio>
              <el-radio :label=1>
                女
              </el-radio>
            </el-radio-group>
          </td>
        </tr>
      </table>
      <span slot="footer">
        <el-button @click=" dialogVisable= false">取 消</el-button>
        <el-button type="primary" @click="update">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import * as userApi from '@/api/adminApi/zh/user';
export default {
  data() {
    return {
      total: 0,
      searchModel: {
        pageNo: 1,
        pageSize: 10
      },
      viewDialogVisable: false,
      dialogImageMainUrl: '',
      dialogImagePrarUrl: '',
      userParam: {},
      dialogVisable: false,
      dialogTitle: '新增用户信息',
      userList: []
    };
  },
  methods: {
    newUser() {
      this.dialogTitle = '新增用户信息';
      this.dialogVisable = true;
    },
    getUserDetail(rowId, type) {
      userApi.getUser({ userId: rowId }).then(res => {
        this.userParam = res.data;
        if (type === 1) {
          this.viewDialogVisable = true;
        } else {
          this.dialogTitle = '编辑产品信息';
          this.dialogVisable = true;
        }
      });
    },
    delUser(rowId) {
      this.$confirm('是否确认删除此用户', {
        distinguishCancelAndClose: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          userApi.delUser({ userId: rowId }).then(res => {
            this.getUserList();
          });
        })
        .catch(action => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
    },
    update() {
      if (this.userParam.userId) {
        userApi.upUser(this.userParam).then(res => {
          this.getUserList();
          this.dialogVisable = false;
        });
      } else {
        userApi.addUser(this.userParam).then(res => {
          this.getUserList();
          this.dialogVisable = false;
        });
      }
    },
    getUserList() {
      userApi.getUserList(this.searchModel).then(res => {
        this.userList = res.data.records;
        this.total = res.data.total;
      });
    }
  },
  created() {
    this.getUserList();
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/adminCenter/page/user/index.vue